import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    FieldContentDynamicStyleConstantType,
    FieldContentDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column"
    }
});

export const useStyles = ({
    isHorizontal,
    spaces
}: FieldContentDynamicStyleConstantType): FieldContentDynamicStyleType => {
    const container = {
        gap: spaces.spacingXs
    } as Mutable<ViewStyle>;

    if(isHorizontal) {
        container.flexBasis = "auto";
        container.flexShrink = 1;
        container.flexGrow = 1;
        container.minWidth = 0;
    }

    return {
        container
    };
};
export default stylesheet;
